<div class="tutorial-options">
  @for (cls of classPresetOptions; track cls.key) {
    <div class="tutorial-option preset-option class-option" [class.selected]="filter.classPreset === cls.key" (click)="setClassPreset(cls.key)">
      <h3>{{ cls.key }}</h3>
      <div class="preset-image-wrap">
        <img class="tutorial-option-image" [src]="cls.img"/>
        <button type="button" class="preset-preview-btn" title="Preview changes" (click)="previewClassPreset(cls.key); $event.stopPropagation()">
          <span class="icon icon-zoom-in"></span>
        </button>
      </div>
    </div>
  }
</div>

<p class="preset-info extra-info">
  @if (filter.classPreset) {
    {{ classPresetTexts[filter.classPreset!] }}
  }
</p>
